export type GetComponentProjectListResponse = {
  cpntPjtList: GetCpntPjt[];
};
export type GetCpntPjt = {
  pjtId?: string;
  cpntPjtTypeCd?: string;
  cpntPjtTypeName?: string;
  pjtName?: string;
  pjtSts?: string;
  dipByRgn?: string;
  rootCpntId?: string;
  cpntId?: string;
  cpntName?: string;
  cpntPrtclCtgryTypeCd?: string;
  inOutTypeCd?: string;
  inOutTypeName?: string;
  prtcolTypeCd?: string;
  prtcolTypeName?: string;
  ptnrId?: string;
  ptnrName?: string;
  delPjtFlg?: string;
  stgOnlyFlg?: string;
  othrStgStupFlg?: string;
  stgSchedDplymntDate?: string;
  prdSchedDplymntDate?: string;
  stgIfdDplymntPsblFlg?: string;
  prdIfdDplymntPsblFlg?: string;
  reqTskSlctdFlg?: string;
  updateDateTime?: string;
  relatedifpjtNames?: string;
  stgDplymntPlnFirstDate?: string;
  prdDplymntPlnFirstDate?: string;
  designTcktId?: string;
  designTcktStsTypeCd?: string;
  stgDplymntTcktId?: string;
  stgDplymntTcktStsTypeCd?: string;
  prdDplymntTcktId?: string;
  prdDplymntTcktStsTypeCd?: string;
};
